import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs, { Tab } from '@adsk/alloy-react-tabs';
import { useLocale } from '@adsk/alloy-react-helpers';
import { PREDEFINED_PROJECT_ADMIN_SETTINGS_TABS_IDS } from '@common/constants';
import ProjectTabContent from '../ProjectTabContent';
import { tabsStyle, tabStyle } from './styles';

const PageHeaderTabs = ({ activeTab, tabs, onProfileSave, onTabChange }) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const [controlledActiveTab, setControlledActiveTab] = useState(activeTab);

  useEffect(() => {
    setControlledActiveTab(activeTab);
  }, [activeTab]);

  const renderTab = ({ tab, label, url, content, labelProps, ...rest }) => {
    if ((url && content) || (!url && !content)) {
      throw new Error(
        'Either one of "url" or "content" properties should be provided.'
      );
    }

    let computedLabelProps;

    if (labelProps || url) {
      computedLabelProps = {
        ...(labelProps && labelProps),
        ...(url && { as: 'a', href: url }),
      };
    }

    const props = {
      key: tab,
      tab,
      label,
      ...(url && {
        onClick: () => {
          window.location.href = url;
        },
      }),
      ...(computedLabelProps && { labelProps: computedLabelProps }),
      ...rest, // This makes sure any new prop added to the Tab component will also be passed
    };

    return content ? (
      <Tab style={tabStyle} {...props}>
        {content}
      </Tab>
    ) : (
      <Tab {...props} />
    );
  };

  return (
    <Tabs
      style={tabsStyle}
      active={controlledActiveTab}
      onChange={(tab) => {
        if (onTabChange) onTabChange(tab);
        setControlledActiveTab(tab);
      }}
    >
      <Tab
        style={tabStyle}
        tab={PREDEFINED_PROJECT_ADMIN_SETTINGS_TABS_IDS.PROJECT}
        label={T.translate('PROJECT_TAB_LABEL')}
      >
        <ProjectTabContent onProfileSave={onProfileSave} />
      </Tab>
      {tabs.map(renderTab)}
    </Tabs>
  );
};

PageHeaderTabs.propTypes = {
  activeTab: PropTypes.string,
  tabs: PropTypes.array,
  onProfileSave: PropTypes.func,
  onTabChange: PropTypes.func,
};

export default PageHeaderTabs;
